import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import Table from 'components/Motion_Detection/Alarm_FTP_Upload/Table';
import NavButtons from 'components/Motion_Detection/Alarm_FTP_Upload/NavButtons';
import ForumBox from 'components/Motion_Detection/Alarm_FTP_Upload/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  Table,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};